define(function(require) {
    // GEO07E21_SCENARIOS layer definition config
    return {
        LAYER_ID : "GEO07E21_SCENARIOS",
        LAYER_TYPE : "POLYGON",
        USE_TYPED_ARRAY : true,
        LOADING_MODE : "INITIAL",
        TOKEN_REQUIRED: true,
        INDEX : 15,
        DATATABLE_ID : "t_GEO07E21_SCENARIOS",
        QUERY_FIELDS : ["SECTEUR", "NOM_SECTEUR", "CD_COULR", "SCENARIO", "CD_TA_SEC", "CD_BASSIN", "NOM_BASSIN", "FRANCO", "ANGLO"],
        FIELDS : [
            {ID: "SECTEUR", NAME: "Code", DATA_TYPE: "STRING", VALUE: "{{SECTEUR}}"},
            {ID: "NOM_SECTEUR", NAME: "Nom", DATA_TYPE: "STRING", VALUE: "{{NOM_SECTEUR}}"},
            {ID: "CD_COULR", NAME: "CD_COULR", DATA_TYPE: "STRING", VALUE: "{{CD_COULR}}"},
            {ID: "SCENARIO", NAME: "Scénario", DATA_TYPE: "STRING", VALUE: "{{SCENARIO}}"},
            {ID : "CD_TA_SEC", NAME : "Code territoire d’analyse (secondaire)", DATA_TYPE: "STRING", VALUE : "{{CD_TA_SEC}}"},
            {ID : "CD_BASSIN", NAME : "Code", DATA_TYPE: "STRING", VALUE : "{{CD_BASSIN}}"},
            {ID : "NOM_BASSIN", NAME : "Nom", DATA_TYPE: "STRING", VALUE : "{{NOM_BASSIN}}"},
            {ID : "FRANCO", NAME : "Franco", DATA_TYPE: "STRING", VALUE : "{{FRANCO}}"},
            {ID : "ANGLO", NAME : "Anglo", DATA_TYPE: "STRING", VALUE : "{{ANGLO}}"},
        ],
        STYLES: [
            {
                ID: "Scénario_1",
                VALUE: 1,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "NONE",
                        STROKE_COLOR: "rgba(253,0,0,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 3
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(253,0,0,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: false
                }
            }, {
                ID: "Scénario_2",
                VALUE: 2,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "NONE",
                        STROKE_COLOR: "rgba(1,178,75,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 3
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(1,178,75,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: false
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Scénario",
            // FEATURE_ID_DATACOLUMN : "CD_TA_PRIM",
            // FEATURE_NAME_DATACOLUMN : "CD_TA_PRIM",
            //DATATIP_DATACOLUMNS : ["CD_TA_PRIM"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["SECTEUR", "NOM_SECTEUR", "SCENARIO", "CD_TA_SEC", "CD_BASSIN", "NOM_BASSIN", "FRANCO", "ANGLO"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["SECTEUR", "NOM_SECTEUR", "SCENARIO", "CD_TA_SEC", "CD_BASSIN", "NOM_BASSIN", "FRANCO", "ANGLO"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            //SEARCHABLE_DATACOLUMNS : ["CD_TA_PRIM", "CD_CS"],
            SHOW_STYLES_IN_LAYER_CONTROL : true,
            STYLE_DATACOLUMN: "CD_COULR",
            //LABEL_DATACOLUMN : "CD_TA_PRIM",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : false,
                LEADER_LINES : false,
                POSITION : "MIDDLE-CENTER",
                PRIORITY : 5
            },
            VISIBLE : false,
            BLEND_MODE : "NORMAL",
        }
    };
});
